import React from "react";
import { Info } from "lucide-react";

export const SeeMoreButton = ({ handleMoreInfoClick }) => {
  return (
    <button
      onClick={handleMoreInfoClick}
      className="flex items-center px-2 py-1 text-xs text-black bg-white rounded lg:text-base"
    >
      <Info className="mr-1" size={16} />
      Ver más
    </button>
  );
};
